
import type { Organism } from '@verndale/core';

const globModules: Organism[] = [
  {
    name: 'alphabet-filtered-links-list',
    loader: () => import('./modules/alphabet-filtered-links-list')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'video',
    loader: () => import('./modules/video.js')
  },
  {
    name: 'horizontal-top-navigation-row',
    loader: () => import('./modules/horizontal-top-navigation-row')
  },
  {
    name: 'staff-gallery-row',
    loader: () => import('./modules/staff-gallery-row')
  },
  {
    name: 'h1-heading',
    loader: () => import('./modules/h1-heading')
  },
  {
    name: 'accordion-with-colored-cards',
    loader: () => import('./modules/accordion-with-colored-cards')
  },
  {
    name: 'return-to-top',
    loader: () => import('./modules/return-to-top')
  },
  {
    name: 'locations-map-row',
    loader: () => import('./modules/locations-map-row')
  },
  {
    name: 'map',
    loader: () => import('./modules/map')
  },
  {
    name: 'modal-link-button',
    loader: () => import('./modules/modal-link-button')
  },
  {
    name: 'image-carousel-row',
    loader: () => import('./modules/image-carousel-row'),
  },
  {
    name: 'accordion-content-row',
    loader: () => import('./modules/accordion-content-row'),
  },
  {
    name: 'actions-list',
    loader: () => import('./modules/actions-list'),
  },
  {
    name: 'simple-condition-search-masthead',
    loader: () => import('./modules/simple-condition-search-masthead'),
  },
  {
    name: 'publications-row',
    loader: () => import('./modules/publications-row'),
  }
];

export default globModules;
